"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __importDefault(require("licia/$"));
var uniqId_1 = __importDefault(require("licia/uniqId"));
var find_1 = __importDefault(require("licia/find"));
var h_1 = __importDefault(require("licia/h"));
var Component_1 = __importDefault(require("../share/Component"));
var Notification = (function (_super) {
    __extends(Notification, _super);
    function Notification(container, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, container, { compName: 'notification' }, options) || this;
        _this.notifications = [];
        _this.initOptions(options, {
            position: {
                x: 'right',
                y: 'bottom',
            },
            duration: 2000,
        });
        _this.initTpl();
        return _this;
    }
    Notification.prototype.notify = function (content, options) {
        var _this = this;
        if (options === void 0) { options = {
            duration: this.options.duration,
        }; }
        var notification = new NotificationItem(this, content);
        this.notifications.push(notification);
        this.add(notification);
        setTimeout(function () { return _this.remove(notification.id); }, options.duration);
    };
    Notification.prototype.dismissAll = function () {
        var notifications = this.notifications;
        var notification = notifications[0];
        while (notification) {
            this.remove(notification.id);
            notification = notifications[0];
        }
    };
    Notification.prototype.add = function (notification) {
        this.container.appendChild(notification.container);
    };
    Notification.prototype.remove = function (id) {
        var notifications = this.notifications;
        var notification = (0, find_1.default)(notifications, function (notification) { return notification.id === id; });
        if (!notification)
            return;
        notification.destroy();
        var idx = notifications.indexOf(notification);
        notifications.splice(idx, 1);
    };
    Notification.prototype.initTpl = function () {
        var $container = this.$container;
        var _a = this.options.position, x = _a.x, y = _a.y;
        var justifyContent = 'flex-end';
        var alignItems = 'flex-end';
        switch (x) {
            case 'center':
                alignItems = 'center';
                break;
            case 'left':
                alignItems = 'flex-start';
                break;
        }
        if (y === 'top')
            justifyContent = 'flex-start';
        $container.attr('style', "justify-content: ".concat(justifyContent, "; align-items: ").concat(alignItems));
    };
    return Notification;
}(Component_1.default));
exports.default = Notification;
var NotificationItem = (function () {
    function NotificationItem(notification, content) {
        this.container = (0, h_1.default)('div');
        this.$container = (0, _1.default)(this.container);
        this.notification = notification;
        this.content = content;
        this.id = (0, uniqId_1.default)('luna-notification-');
        this.$container.attr({
            id: this.id,
            class: notification.c("item ".concat(notification.getOption('position').y === 'bottom' ? 'lower' : 'upper')),
        });
        this.initTpl();
    }
    NotificationItem.prototype.destroy = function () {
        this.$container.remove();
    };
    NotificationItem.prototype.initTpl = function () {
        this.$container.html(this.notification.c("<div class=\"content\">".concat(this.content, "</div>")));
    };
    return NotificationItem;
}());
module.exports = Notification;
module.exports.default = Notification;
